<template>
    <div id="enterpriseWebsite">
        <!-- top -->
        <div class="enterpriseWebsite-top">
            <div class="enterpriseWebsite-top-title">
                <span>企业网站</span>
                <!-- 提示帮助图标 -->
                <div class="attention">
                    <div class="attention-model">
                        <i></i>
                        <ul>
                            <li>
                                <p>来访次数
                                    <span>1天内由该来源进入网站的访问次数</span>
                                </p>
                            </li>
                            <li>
                                <p>独立访客(UV)
                                    <span>1天内由该来源进入网站的不重复用户数</span>
                                </p>
                            </li>
                            <li>
                                <p>IP
                                    <span>1天内由该来源进入网站的不重复IP数</span>
                                </p>
                            </li>
                            <li>
                                <p>浏览页数(PV)
                                    <span>由该来源进入网站的访客在网站上产生的总PV</span>
                                </p>
                            </li>
                            <li>
                                <p>人均浏览页数
                                    <span>由该来源进入网站的每个独立访客平均产生的PV</span>
                                </p>
                            </li>
                            <li>
                                <p>平均访问深度
                                    <span>由该来源进入网站的每次访问(会话)平均产生的PV</span>
                                </p>
                            </li>
                            <li>
                                <p>平均访问时长
                                    <span>平均每次访问在网站上的停留时间</span>
                                </p>
                            </li>
                            <li>
                                <p>跳出率
                                    <span>仅浏览了1个页面就离开网站的访问次数占比</span>
                                </p>
                            </li>
                            <li>
                                <p>输出PV
                                    <span>由该页面点击到站内其他页面的PV</span>
                                </p>
                            </li>
                            <li>
                                <p>平均停留时长
                                    <span>访客打开页面到离开该页面的平均时间差</span>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="searchCondition">
            <div class="searchLine">
                <div class="searchUnit">
                    <label>企业名称</label>
                    <el-select  @change="companyChange" v-model="companyVar">
                        <el-option v-for="item in companyOpts" :key="item.company" :label="item.company" :value="item.company">
                        </el-option>
                    </el-select>
                </div>
                <div class="searchUnit">
                    <label>企业网站</label>
                    <el-select v-model="websiteVar">
                        <el-option v-for="item in websiteOpts" :key="item.key" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="searchUnit">
                    <label>分析类别</label>
                    <el-select v-model="typeVar">
                        <el-option v-for="item in typeOpts" :key="item.key" :label="item.value" :value="item.value">
                            <span style="float: left">{{ item.value }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label }}</span>
                        </el-option>
                    </el-select>
                </div>
                <div class="searchUnit">
                    <!-- 日期选择器 -->
                    <el-date-picker @change="dateRangeChange" v-model="datePickerModel" type="daterange" align="right" :placeholder="this.selected.startTime +' - '+ this.selected.endTime" :picker-options="DatePickerOptions">
                    </el-date-picker>
                </div>
                <div class="button">
                    <button @click="searchForCondition">搜索</button>
                    <a @click="export_analyze()" class="derive"></a>
                </div>
            </div>
        </div>
        <!-- content -->
        <div class="enterpriseOrder-content">
            <!-- table栏 -->
            <el-table :data="tableData" style="width: 95%">
                <el-table-column v-for="item in title" :prop="item.prop" :label="item.label" :key="item.label" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <!-- 导入子组件-分页器 -->
            <subpagination :totalToPag="companyTotal" @current-change="getCurrentListData"></subpagination>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import qs from 'qs';
    // 导入分页子组件
    import subpagination from "../subcomponent/subPaginationCom.vue";
    //导入企业网站的样式
    import '../../statics/css/enterpriseWebsite.scss';
    export default {
        data() {
            return {
                title:[],
                origin_title: [
                    {prop: "origin_desc",label: ""},
                    {prop: "visit_num",label: "来访次数"},
                    {prop: "visitor_num",label: "独立访客(UV)"},
                    {prop: "ip",label: "IP"},
                    {prop: "page_num",label: "浏览页数（PV）"},
                    {prop: "visitor_average",label: "人均浏览页数"},
                    {prop: "average_depth",label: "平均访问深度"},
                    {prop: "average_time",label: "平均访问时长"},
                    {prop: "jump_rate",label: "跳出率"},
                ],
                view_title: [
                    {prop: "url",label: "受访页面"},
                    {prop: "visitor_num",label: "独立访客(UV)"},
                    {prop: "page_num",label: "浏览页数（PV）"},
                    {prop: "ip",label: "IP"},
                    {prop: "visitor_average",label: "人均浏览页数"},
                    {prop: "link_num",label: "输出PV"},
                    {prop: "average_time",label: "平均停留时长"},
                ],
                tableData: [],
                companyOpts: [],
                companyVar: '',
                websiteOpts: [],
                websiteVar: '',
                selected: {
                    startTime: "",
                    endTime: "",
                    server_uid: "",
                    prefix: "",
                    domain: ""
                },
                typeOpts: [{
                        key: 0,
                        value: '来源分析',
                        label: '来源分析'
                    }, {
                        key: 1,
                        value: '搜索引擎',
                        label: '来源分析'
                    }, {
                        key: 2,
                        value: '外部链接',
                        label: '来源分析'
                    }, {
                        key: 3,
                        value: '受访分析',
                        label: '受访分析'
                }],
                typeVar: '',
                // 日期选择器设置
                DatePickerOptions: {
                    shortcuts: [{
                        text: '最近60天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近30天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近7天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                //绑定日期选择器
                datePickerModel: "",
                //公司总数
                companyTotal:0,
                page:0,
                alltableData:[]
            }
        },
        created() {
            this.setDate(30);
            this.i_companies();
        },
        methods:{
            //搜索
            searchForCondition(){
                this.tableData = [];
                this.r_tableData()
            },
            r_websites(){
                var company_info = this.companyOpts.find(o => o.company === this.companyVar)
                var obj =company_info.websites;
                for (var i = 0; i < obj.length; i ++) {
                    this.websiteOpts[i] = {key: obj[i], label: obj[i],value: obj[i]};
                }
                this.websiteVar=obj[0];
                this.selected.prefix=company_info.prefix;
                this.selected.server_uid=company_info.server_uid;
            },
            r_typeVar(){
                this.typeVar="来源分析";
            },
            r_tableData(){
                var tb_title=[];
                this.selected.domain=this.websiteVar;
                switch (this.typeVar)
                {
                    case "来源分析":
                        tb_title = this.origin_title;
                        tb_title.shift();
                        tb_title.unshift({prop: "origin_desc",label: "来源分类"});
                        delete this.selected.origin_type;
                        this.i_origin_analyze();
                        break;
                    case "搜索引擎":
                        tb_title = this.origin_title;
                        tb_title.shift();
                        tb_title.unshift({prop: "origin_desc",label: "搜索引擎"});
                        this.selected.origin_type="1";
                        this.i_origin_analyze();
                        break;
                    case "外部链接":
                        tb_title = this.origin_title;
                        tb_title.shift();
                        tb_title.unshift({prop: "origin_desc",label: "外部链接"});
                        this.selected.origin_type="2";
                        this.i_origin_analyze();
                        break;
                    case "受访分析":
                        tb_title = this.view_title;
                        delete this.selected.origin_type;
                        this.i_visit_analyze();
                        break;
                }
                this.title=tb_title;
            },
            i_companies(){
                this.$ajax.post(
                    "/api/get_websites",
                    qs.stringify({})
                ).then(res => {
                    console.log(res)
                    if (res.data.data.length) {
                        this.companyOpts=res.data.data;
                        this.companyVar = this.companyOpts[0].company;
                        this.r_websites();
                        this.r_typeVar();
                        this.r_tableData();
                    }
                })
                //测试ls
                //this.r_tableData();
            },
            //渲染数据列表
            i_origin_analyze(){
                this.$ajax.post(
                    "/api/origin_analyze",
                    qs.stringify(this.selected)
                ).then(res => {
                    
                    //this.tableData=res.data.data;
                    this.alltableData = res.data.data;
                    this.companyTotal = res.data.data.length;
                    //根据页数显示特定数据
                    for(var j = 15*this.page; j< 15*(this.page+1);j++) {
                        if(this.alltableData[j]) {
                            this.tableData.push(this.alltableData[j]);
                        }
                    }
                })
            },
            i_visit_analyze(){
                this.$ajax.post(
                    "/api/visit_analyze",
                    qs.stringify(this.selected)
                ).then(res => {
                    //this.tableData=res.data.data;
                    this.alltableData = res.data.data;
                    this.companyTotal = this.alltableData.length;
                    //根据页数显示特定数据
                    for(var j = 15*this.page; j< 15*(this.page+1);j++) {
                        if(this.alltableData[j]) {
                            this.tableData.push(this.alltableData[j]);
                            console.log("tableData123",this.tableData)
                        }
                    }
                    //console.log("page",this.page)
                    //console.log("tableData",this.tableData)
                    })

                // this.alltableData =  [
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "百度网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         },
                    //         {
                    //             "origin_desc": "搜狗网页版",
                    //             "visitor_num": 3,
                    //             "visitor_average": 3.33,
                    //             "visit_num": 10,
                    //             "page_num": 10,
                    //             "jump_rate": 1,
                    //             "ip": 2,
                    //             "average_time": 0,
                    //             "average_depth": 1
                    //         }
                // ];
                // this.companyTotal = this.alltableData.length;
                // //console.log("alltableData length",this.alltableData.length)
                // for(var j = 15*this.page; j< 15*(this.page+1);j++) {
                //         if(this.alltableData[j]) {
                //             this.tableData.push(this.alltableData[j]);
                //             //console.log("tableData123",this.tableData)
                //         }
                // }
            },
            setDate(days) { //默认显示最近x天的时间
                var now = new Date();
                var days_before = new Date(now.valueOf() - days * 86400000);
                this.selected.startTime = days_before.Format("yyyy-MM-dd");
                this.selected.endTime = now.Format("yyyy-MM-dd");
            },
            dateRangeChange(val) {  //设置下拉框默认显示时间和显示相应的数据
                if (val) {
                    this.selected.startTime = val.split(" ")[0];
                    this.selected.endTime = val.split(" ")[2];
                }
            },
            companyChange(){
                this.r_websites();
            },
            export_analyze() {
                delete this.selected.origin_type;
                this.$ajax.post(
                    "/api/export_analyze",
                    qs.stringify(this.selected)
                ).then(res => {
                    this.$downloadFile(res.data.data);
                })
            },
            //根据分页器页数获取当前列表数据
            getCurrentListData(page) {
                this.page = page - 1;
                this.searchForCondition()
            },
        },
        // 注册子组件
        components: {
            subpagination
        }
    }

</script>



// WEBPACK FOOTER //
// enterpriseWebsite.vue?b51c43a2